import AbstractLayerManager from './AbstractLayerManager';
import Request from '../../Request';

export default class SkyCamsLayerManager extends AbstractLayerManager {
	constructor(myKey, instance) {
		super(myKey, instance);
		this.name = "Weather Cameras";
		this.popupName = "Weather Cameras";
		this.options.hasPanRefresh = true;
		this.options.hasAutoRefresh = true;
		this.cams = {};
	}
	
	refreshLayer() {
		this.requestCameras();
	}
	
	requestCameras() {
		if(this.tasks.fetchSkyCam === undefined) this.tasks.fetchSkyCam = new Request({
			url: 'https://api.weatherusa.net/v1/feed/skycams',
			link: 'cancel',
			timeout: 30000,
			onSuccess: this.handleResp.bind(this),
			onError: this.handleError.bind(this)
		});

		this.tasks.fetchSkyCam.get({
			bounds: this.inst.map.getBounds().toBBoxString(),
			zoom: this.inst.map.getZoom()
		});
	}

	handleError(err) {
		console.error(err);
	}
	
	handleResp(resp) {
		if(!this.layer) {
			console.error('Could not find layer for layer ID: ' + this.id);
			return false;
		}
		let list = resp.body;

		this.layer.clearLayers();
		this.cams = {};

		for(const [id, data] of Object.entries(list)) {
			this.cams[id] = new L.Marker(new L.LatLng(data.lat, data.lon), {
				icon: new L.Icon({
					iconUrl: '/archive/cache.php?file=' + encodeURIComponent(data.img) + '&width=48&height=32&type=jpg', 
					iconSize: [48, 32],
					iconAnchor: [23, 17]
				}),
				title: data.name,
				alt: ''
			})
			.on('click', this.handleClick, this)
			.addTo(this.layer);
			var contentStr = '<a target="_blank" href="' + data.url + '">' + data.name + '</a><br />' + data.loc + ', ' + data.state + '<br /><img src="/archive/cache.php?file=' + encodeURIComponent(data.img) + '" width="256" alt="No image available" />';
			this.cams[id].desc = contentStr;
			this.cams[id].minWidth = 256;
			this.cams[id].maxHeight = 300;
		}
	}
		
	handleClick(e) {
		this.inst.forwardedClickHandler(this.id, e, e.target.desc);
	}

	getLayerPopupContent(layer) {
		return layer.desc;
	}
}
